import { PRIVACY_POLICY_URL, TERMS_OF_USE_URL } from '@aloft/toolkit-shared';
import { Link } from '@aloft/toolkit-sui';

export const LegalLinks = () => (
  <>
    <Link href={TERMS_OF_USE_URL} isExternal>
      Terms of Use
    </Link>
    |
    <Link href={PRIVACY_POLICY_URL} isExternal>
      Privacy Policy
    </Link>
  </>
);
